import React from 'react';

const Expand = props => {
  const { expanded = false, ...rest } = props;

  return <div className={expanded ? 'expand up' : 'expand down'} {...rest} />;
};

export default Expand;
